import { memo, useEffect } from 'react';
import classes from './agreement.module.scss';

type Props = {};

export const AgreementEnPage = memo((_props: Props) => {
	useEffect(() => {
		document.title = 'Gakken ID Agreement';
	}, []);

	return (
		<>
			<section className={`section ${classes.section_overrie}`}>
				<div className={`section-in ${classes.body_css}`}>
					<div className={classes.top_title}>
						<h1 className={classes.agreement_title}>Gakken ID Agreement</h1>
						<a className={classes.english} href="/agreement">
							Japanese
						</a>
					</div>

					<div className={classes.block01}>
						<h3>{`Article 1. Definitions`}</h3>
						<div className={classes.reg0}>
							The terms used in the Gakken ID Agreement (hereinafter referred to as “this agreement”) shall be defined
							as follows.
						</div>

						<div className={classes.reg1}>
							<ol>
								<li>
									“Gakken” shall refer to the companies comprising the Gakken group, including Gakken Products Support
									Co., Ltd. (hereinafter, the “Company”).
								</li>
								<li>
									“Gakken ID” shall refer to the account ID needed to use these services and eligible services provided
									by Gakken. An ID holder may use the Gakken ID to log into the websites associated with eligible
									services.
								</li>
								<li>
									“ID holder” shall refer to a person who has completed an ID registration application by entering the
									necessary information stipulated by the Company on the webpage for these services, and who has been
									approved by the Company to use a Gakken ID.
								</li>
								<li>
									“ID registration application” shall refer to the application procedures to register to use a Gakken
									ID.
								</li>
								<li>“These services” shall refer to Gakken ID issuance and management services.</li>
								<li>
									“Eligible services” shall refer to the various Gakken services available on the Internet through the
									use of a Gakken ID. These include the provision of information, shopping, billing, settlement, and
									other services. Please refer to the eligible services page for details of eligible services.
								</li>
							</ol>
						</div>
					</div>

					<div className={classes.block01}>
						<h3>Article 2. (Application of the Agreement)</h3>

						<div className={classes.reg1}>
							<ol>
								<li>This agreement shall apply to ID holders.</li>
								<li>
									The content of this agreement may be changed as necessary without notifying ID holders in advance.
									When using these services or eligible services, please check the latest version of this agreement,
									which is displayed on the website associated with these services.
								</li>
								<li>
									An ID holder who uses these services or eligible services, after the Company has changed the content
									of this agreement as in the previous paragraph, shall be deemed to have accepted the changes to this
									agreement.
								</li>
								<li>
									Where the Company has posted precautions or other notes on the website associated with these services,
									such precautions or notes shall form part of this agreement.
								</li>
							</ol>
						</div>
					</div>

					<div className={classes.block01}>
						<h3>Article 3. (Gakken ID Holders)</h3>

						<div className={classes.reg1}>
							<ol>
								<li>
									After the ID registration application has been completed and the use of a Gakken ID has been approved
									by the Company, the applicant may use the eligible services as an ID holder.
								</li>
								<li>
									ID holders shall be deemed to have consented to this agreement from the time when they become ID
									holders.
								</li>
								<li>
									ID Holders shall understand and comply with the following conditions when submitting an ID
									registration application.
								</li>

								<div className={classes.reg2}>
									<p>
										(1) The data necessary to register an ID for the ID holder must be entered truthfully and accurately
										by the ID holder in the input fields on the dedicated ID holder registration page associated with
										these services. No applications for ID registration entered or applied for by proxy shall be
										accepted.
									</p>
									<p>
										(2) An email address belonging to the ID holder must be registered as the email address when
										submitting an ID registration application. Registration using an email address belonging to another
										shall not be accepted.
									</p>
									<p>
										(3) The ID holder must amend the registration details promptly if any changes occur in the data
										registered in (1) above.
									</p>
									<p>(4) An ID holder must not register or hold more than one ID.</p>
									<p>
										(5) ID holders under the age of 18 years old must obtain the consent of parents or guardians before
										submitting an ID registration application.
									</p>
								</div>
								<div className={classes.reg1}>
									<li>
										To use the eligible services, ID holders shall enter the Gakken ID and the password registered when
										submitting the ID registration application. Gakken shall regard any acts undertaken using a Gakken
										ID and password as usage by the ID holder. Even if the Gakken ID or password is stolen or used
										without authorization, the ID holder shall be held responsible, unless this use is the result of
										intentional actions or gross negligence by Gakken.
									</li>
									<li>
										In the event that an ID holder corresponds to any of the following, Gakken may suspend or cancel the
										provision of all or some of these services or eligible services to the ID holder, delete the ID
										holder’s Gakken ID, delete the ID holder’s password, revoke ID holder eligibility, or take any other
										measures necessary, such as claiming damages (including, but not limited to, legal action) without
										notifying the ID holder in advance. Gakken shall not be held responsible for any damage or
										disadvantage to the ID holder that may arise as a result of these measures.
									</li>
								</div>
								<div className={classes.reg2}>
									<p>
										(1) Where Gakken believes that the ID holder has violated, or risks violating, this agreement or the
										user agreements for each eligible service indicated when using each eligible service (hereinafter,
										the “eligible service usage agreements”), or the precautions or other notes pertaining thereto
									</p>
									<p>
										(2) Where the ID holder has engaged in an act that Gakken believes is inappropriate to the operation
										of these services or the eligible services
									</p>
								</div>
								<div className={classes.reg1}>
									<li>
										The ID holder shall confirm and consent to the eligible service usage agreements before using the
										eligible services.
									</li>
								</div>
							</ol>
						</div>

						<div className={classes.block01}>
							<h3>Article 4. (ID Holder Prohibitions)</h3>
							<div className={classes.reg0}>
								The ID holder shall not engage in the following acts, or acts deemed by Gakken to risk corresponding to
								the following acts.
							</div>

							<div className={classes.reg2}>
								<ol>
									<p>
										(1) Acts that violate copyright, portrait right, or another intellectual property right of Gakken,
										another ID holder, or a third party
									</p>
									<p>(2) Acts that violate the property or privacy of Gakken, another ID holder, or a third party</p>
									<p>
										(3) Defamatory acts or acts that cause annoyance or discomfort to Gakken, another ID holder, or a
										third party
									</p>
									<p>
										(4) Unauthorized access to computers, such as the Company’s servers associated with these services,
										writing or sending harmful computer programs or harmful emails
									</p>
									<p>(5) Using these services or eligible services for commercial purposes</p>
									<p>(6) Actions linked to criminal acts</p>
									<p>
										(7) Duplicating or selling information obtained through these services or eligible services, or
										otherwise using this information in a way that exceeds the scope of personal usage
									</p>
									<p>
										(8) Acts that hinder the operation of these services or eligible services, or damage the
										creditability of Gakken or its partners
									</p>
									<p>(9) Sales activities or activities providing information for commercial purposes</p>
									<p>
										(10) Acts that use these services or eligible services to intentionally embarrass Gakken or its
										partners through the provision of false information or through intimidation
									</p>
									<p>
										(11) Any other acts that violate laws, regulations, public order and morality, or this agreement, or
										risk such a violation
									</p>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>Article 5. (Non-guarantee)</h3>
							<div className={classes.reg0}>
								When providing these services and eligible services, Gakken endeavors to deliver trustworthy services
								and information to ID holders but makes no guarantee regarding any of the following matters. When using
								these services and eligible services, ID holders are requested to judge for themselves the usefulness
								and other attributes of the information and services provided through them.
							</div>

							<div className={classes.reg2}>
								<ol>
									<p>
										(1) The usefulness, suitability, completeness, accuracy, safety, legality, currentness, and other
										attributes of any information provided through these services and eligible services (including any
										information included in eligible services or on websites, administrated or operated by third
										parties, to which links are displayed in eligible services; the same applies hereinafter)
									</p>
									<p>
										(2) The appropriateness of products, services, information, or other content obtained through these
										services or eligible services, including whether they satisfy the hopes or expectations of the ID
										holder
									</p>
									<p>
										(3) The absence of any malfunction, error, or failure in the provision of these services or eligible
										services
									</p>
									<p>
										(4) The absence of any harmful content, such as computer viruses, in the emails or other online
										content sent in relation to these services or eligible services
									</p>
									<p>(5) The continuation or maintenance of the integrity of these services or eligible services</p>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>Article 6. (Responsibilities of Gakken and ID Holders)</h3>

							<div className={classes.reg1}>
								<ol>
									<li>
										Gakken shall not be held responsible for any damage arising from the use or unavailability of these
										services or eligible services (including, but not limited to, the damages set forth in each item
										below, mental anguish suffered by the ID holder or a third party, or other disadvantages, including
										pecuniary losses), except in the case of intentional acts or gross negligence by Gakken. Even in
										cases where Gakken is held responsible, Gakken’s responsibility shall be limited to direct and
										ordinary damages.
									</li>
									<div className={classes.reg2}>
										<p>
											(1) Damage to the ID holder resulting from acts such as downloading content provided by a third
											party through these services or eligible services, or accessing a website administrated or
											operated by a third party via a link from these services or eligible services
										</p>
										<p>
											(2) Damage to the ID holder resulting from wrongdoing, such as unauthorized alteration of these
											services or eligible services, unauthorized access to data related to these services or eligible
											services, or contamination by a computer virus, despite suitable safety measures implemented by
											Gakken
										</p>
										<p>
											(3) Damage resulting from the suspension, delay, or cancellation of systems or services or the
											loss of data caused by the malfunction of communication lines, computers, etc., or unauthorized
											access
										</p>
									</div>
									<li>
										Where Gakken or a third party has suffered damage due to actions by the ID holder in violation of
										this agreement or an eligible service usage agreement, the ID holder must provide full compensation
										at the ID holder’s own responsibility and expense.
									</li>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>Article 7. (Handling of Personal Information)</h3>

							<div className={classes.reg1}>
								<ol>
									<li>
										The Company shall respect the privacy of ID holders, and manage the personal information of ID
										holders with diligence and care. Personal information obtained by the Company from ID holders in the
										administration and operation of these services shall be handled in accordance with the
										separately-established Privacy Policy (
										<a className={classes.close} href="https://gakken-ps.co.jp/english/privacypolicy/" target="_blank">
											https://gakken-ps.co.jp/english/privacypolicy/
										</a>
										).
									</li>
									<li>The Company shall share the personal information of ID holders as described below.</li>
									<div className={classes.reg2}>
										<p>1) Items of personal information to be shared</p>
									</div>
									<div className={classes.reg3}>
										<p>
											All personal information that has been registered with a Gakken ID (including the attribute
											information and behavioral history designated under Article 8.)
										</p>
									</div>
									<div className={classes.reg2}>
										<p>2) Scope of information sharing</p>
									</div>
									<div className={classes.reg3}>
										<p>Companies comprising the Gakken group, including the Company</p>
									</div>
									<div className={classes.reg2}>
										<p>3) Purposes of information sharing</p>
									</div>
									<div className={classes.reg3}>
										<p>
											(i) Provision of services related to the businesses of other Gakken group companies, such as
											e-commerce websites (including eligible services), and actions incidental to the provision of
											these services (marketing, new product and service planning and development, etc.)
										</p>
										<p>
											(ii) Information and guidance on products and services provided by companies in the Gakken group
											and their third-party partners. This includes information and guidance on products and services
											tailored to ID holders’ interests, based on the analysis of information obtained such as the
											attribute information and behavioral history designated under Article 8.
										</p>
									</div>
									<div className={classes.reg2}>
										<p>
											4) Name, address, and representative of the body responsible for managing personal information
										</p>
									</div>
									<div className={classes.reg3}>
										<p>Gakken Products Support Co., Ltd.</p>
										<div className={classes.reg3}>
											<p>
												Please refer to the following website for details of the company address and representative:
											</p>
											<div className={classes.reg3}>
												<p>
													<a
														className={classes.close}
														href="https://gakken-ps.co.jp/company/about.html"
														target="_blank"
													>
														https://gakken-ps.co.jp/company/about.html
													</a>
												</p>
											</div>
										</div>
									</div>
									<li>
										Even if the ID holder cancels the eligible services or withdraws from the membership plan associated
										with an individual eligible service (regardless of the reason for this cancellation or withdrawal),
										the Company may, with the ID holder’s deemed consent, continue to hold and use the ID holder’s
										personal information unless the ID holder deletes the Gakken ID by following the procedures
										separately designated by the Company.
									</li>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>Article 8. (Collection and Use of Attribute Information and Behavioral History)</h3>

							<div className={classes.reg1}>
								<ol>
									<li>
										The ID holder consents to Gakken obtaining attribute information provided through these services or
										the eligible services, such as age, sex, occupation, and residential area, and the history of the ID
										holder’s behavior on eligible services, as well as using this information within the scope necessary
										for the provision of eligible services. Furthermore, the ID holder consents to the unlimited use of
										statistical data prepared based on this attribute information and behavioral history. Gakken shall
										not disclose information enabling the identification of the ID holder to any third party, except
										where required in accordance with the law, or where the consent of the ID holder has been obtained.
									</li>
									<li>
										Where the ID holder has logged in to use the eligible services with a Gakken ID, the ID holder
										consents to Gakken identifying the ID holder and using existing attribute information and behavioral
										history to deliver and display advertising, etc., and to provide eligible services.
									</li>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>Article 9. (Alteration, Suspension, and Cancellation of Eligible Services)</h3>

							<div className={classes.reg1}>
								<ol>
									<li>
										Gakken may alter, suspend, or cancel all or part of these services and eligible services without
										notifying ID holders in advance. However, Gakken shall notify ID holders, using the method
										predesignated by Gakken, in the event that it cancels all of these services and eligible services.
									</li>
									<li>
										Gakken shall not be held responsible for any damage or disadvantage to the ID holder that may arise
										as a result of the partial or total alteration, suspension, or cancellation of these services or
										eligible services.
									</li>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>Article 10. (Elimination of Antisocial Forces)</h3>
							<div className={classes['reg0-sub']}>
								The ID holder declares no association with antisocial forces (including criminal organizations, members
								thereof, persons who have been members within the past five years, associate members of criminal
								organizations, companies associated with criminal organizations, extortionists that target shareholder
								meetings, extortionists pretending to advocate social movements, organized crime syndicates, and other
								equivalent antisocial forces), and that the ID holder shall not engage in any illegal acts, such as
								violent, fraudulent, or intimidatory behavior or obstruction of business, both now and in the future. In
								the event that an ID holder violates this declaration, the ID holder shall accept, without objection,
								the suspension or cancellation of these services and eligible services, deletion of the ID holder’s
								Gakken ID, deletion of the ID holder’s password, revocation of ID holder eligibility, and other measures
								such as claims for damages (including, but not limited to, legal action).
							</div>
						</div>

						<div className={classes.block01}>
							<h3>Article 11. (Prohibition of the Transfer of Rights and Obligations)</h3>
							<div className={classes['reg0-sub']}>
								The ID holder must not transfer the status of ID holder pertaining to these services and eligible
								services, or the rights and obligations based on this status, to a third party, or pledge them as
								security, without the prior consent of the Company.
							</div>
						</div>

						<div className={classes.block01}>
							<h3>Article 12. (Governing Law and Jurisdiction)</h3>
							<div className={classes['reg0-sub']}>
								This agreement shall be interpreted based on the laws of Japan, and the district court or summary court
								with jurisdiction over the location of the Company’s head office shall be the agreed court of first
								instance with exclusive jurisdiction in the case of any dispute related to this agreement.
							</div>
						</div>

						<div className={classes.block02}>
							<h3></h3>
							<div>
								<p>Supplementary Provisions</p>
								<p>Established and enforced on January 1, 2018</p>
								<p>Revised on July 15, 2020</p>
								<p>Revised on February 1, 2021</p>
								<p>Revised on March 28, 2022</p>
							</div>
						</div>
					</div>

					<br />
					<div className={classes['c-bg_box_Border']}>
						<p>
							<a className={classes.close} href="#" onClick={() => window.close()}>
								Close
							</a>
						</p>
					</div>
				</div>
			</section>
		</>
	);
});
